import { Component, OnInit, ViewChild, Inject, TemplateRef } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { DenunciaService } from 'src/app/service/denuncia/denuncia.service';
import { OK_MANIFESTO_ENVIADO, ERRO_DADOS_NAO_GRAVADOS, ERRO_DADOS_OBRIGATORIOS, ERRO_ASSUNTO_OBRIGATORIO, MSG_POPUP_CONFIRMACAO_DENUNCIA, OK_PROTOCOLO_DENUNCIA_ANONIMA } from 'src/app/tools/Mensagens';
import { URL, PAGINA_HOME_DENUNCIA_ANONIMA, PAGINA_SUCESSO_FORM, PAGINA_LOGIN} from 'src/app/tools/URL';
import { FILE_UPLOADER } from 'src/app/componentes/file-uploader/file-uploader.component';
import { DenunciaVO } from 'src/app/entity/DenunciaVO';
import { AbstractControl, FormGroup } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmWindowComponent } from 'src/app/componentes/confirm-window/confirm-window.component';
import { ResponseHandler } from 'src/app/entity/ResponseHandlerDTO';

@Component({
  selector: 'denuncia-anonima',
  templateUrl: './denuncia-anonima.component.html',
  styleUrls: ['./denuncia-anonima.component.css']
})
export class DenunciaAnonimaComponent implements OnInit {
  anonimoMarcado: Boolean = false;
  @ViewChild(FILE_UPLOADER, { static: false }) fileUploader;
  modalRef: BsModalRef;
  message: string;
  mensagemPopUpDenuncia = MSG_POPUP_CONFIRMACAO_DENUNCIA;
  camposNaoPreenchidos: String = "";

  CLASSIFICACAO_CARTORIO_EXTRAJUDICIAL_CAPITAL = 52;
  CLASSIFICACAO_CARTORIO_EXTRAJUDICIAL_INTERIOR = 53;
  CLASSIFICACAO_SERVIDOR_INTERIOR = 60;

  manifesto: any;

  urlDenuncia = URL.DENUNCIA;

  constructor(
    public service: DenunciaService,
    public authService: AuthService,
    private router: Router,
    public dialog: MatDialog,
    public modalService: BsModalService
    ) {

    this.manifesto = {
      id: '-',
      numeroDenunciaAnonima: ''
    };
  }

  ngOnInit() {

    this.service.carregarDadosDenunciaAnonima().subscribe(retorno => {
      //this.service.denuncia.controls.nome.setValue(this.authService.usuarioDTO.nome);
      //this.service.denuncia.controls.email.setValue(this.authService.usuarioDTO.email);
      if (retorno) {
        this.service.denuncia.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
        this.service.denuncia.controls.listaUnidade.setValue(retorno.listaUnidade);
        this.service.denuncia.controls.assuntos.setValue(retorno.assuntos);
        this.service.denuncia.controls.listaMunicipio.setValue(retorno.listaMunicipio);
        this.service.denuncia.controls.listaComarcas.setValue(retorno.listaComarcas);

        this.checarAssuntoUnico();
      }
    });

  }

  checarAssuntoUnico() {
    if (this.service.denuncia.controls.assuntos.value != null && this.service.denuncia.controls.assuntos.value.length == 1) {
      this.changeAssunto(this.service.denuncia.controls.assuntos.value[0]);
    }
  }

  alterarStatusAnonimo() {
    this.anonimoMarcado = !this.anonimoMarcado;
    this.service.denuncia.value.anonimo = this.anonimoMarcado;
  }

  resetForm() {
    this.service.denuncia.reset();
  }

  onSubmit() {
    if (this.service.denuncia.value.assunto) {
      this.preencherDados();

      if (this.service.denuncia.valid) {
        this.service.enviarDenunciaAnonima(this.service.denuncia.value).
        //subscribe(retorno => {
          subscribe((responseHandler: ResponseHandler) => {
          //if (retorno) {
          if (responseHandler) {
            //alert(OK_MANIFESTO_ENVIADO);
            //this.router.navigate([PAGINA_SUCESSO_FORM]);
            this.manifesto.id = responseHandler.data.id;
            this.manifesto.numeroDenunciaAnonima = responseHandler.data.numeroDenunciaAnonima.replace(/(.{3})(?=.)/g, "$1-");
            //alert(OK_PROTOCOLO_DENUNCIA_ANONIMA(this.manifesto.id));
            //this.router.navigate([DENUNCIA_ANONIMA_SUCESSO]);
          } else {
            alert(ERRO_DADOS_NAO_GRAVADOS);
          }
        });
      } else {
        const campos = this.tratarMensagemDeErro();
        alert(ERRO_DADOS_OBRIGATORIOS + campos);
      }
    } else {
      alert(ERRO_ASSUNTO_OBRIGATORIO);
    }
  }

  isValidoRegrasDenuncia() {
    var mensagemErro = this.service.validaCamposDenunciaService(this.service.denuncia);

    if(mensagemErro.length > 0){
      //alert(mensagemErro);
      this.camposNaoPreenchidos = mensagemErro;
      return false;
    }

    return true;
  }

  preencherDados() {
    //this.service.denuncia.controls.nome.setValue(this.authService.usuarioDTO.nome);
    //this.service.denuncia.controls.email.setValue(this.authService.usuarioDTO.email);
    this.service.denuncia.value.files = [];
    this.fileUploader.mapFilesBase64.forEach((value, key) => {
      this.service.denuncia.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });
  }

  tratarMensagemDeErro() {
    let campos: String[] = [];
    let construtor: any = DenunciaVO.prototype.constructor;
    Object.values(this.service.denuncia.controls).forEach((value: AbstractControl) => {
      if (!value.valid) {
        const formGroup = value.parent.controls;
        campos.push('\n' + construtor.descricaoAtributos[Object.keys(formGroup).find(name => value === formGroup[name])]);
      }
    });
    return campos;
  }

  changeAssunto(item) {
    this.service.denuncia.controls.assunto.setValue(item);
  }

  isChecked(item) {
    return this.service.denuncia.controls.assunto.value == item;
  }

  // Método que realiza a abertura do modal, caso as validações sejam aceitas. Caso contrário, será apresentado apenas mensagem de erro.
  openModalPopUp(template: TemplateRef<any>) {
    //this.openDialog();
    this.onSubmit();
    if (this.service.denuncia.value.assunto) {
      this.preencherDados();

      if (this.isValidoRegrasDenuncia()) {
        // Chamada usando o proprio componente - ERRRO - Não esta identificando o template
        //this.modalRef = this.modalService.show(ConfirmWindowComponent, {class: 'modal-sm'});
        // Chamada usando o componente já estabelecido no denuncia.component.html (OK)
        //this.modalRef = this.modalService.show(template, {class: 'modal-sm'});
        this.modalRef = this.modalService.show(template, {
          class: 'modal-sm',
          initialState: {
            // Outras propriedades iniciais do modal
          },
          backdrop: 'static', // opcional, para impedir que o modal seja fechado ao clicar fora dele
          animated: true // opcional, para adicionar uma animação ao abrir o modal
        });

      } else {

        // Utilizando solução das validações sendo passadas para o service, não há a necessidade de atribuir mensagens de erros mais desta forma pois a mensagem de erro será
        // passada na propria validação.
        // TODO Verificar se o código precisará ser retirado.

        //const campos = this.tratarMensagemDeErro();
        //campos.push(this.camposNaoPreenchidos);
        //this.camposNaoPreenchidos = "";
        //alert(ERRO_DADOS_OBRIGATORIOS + campos);

        //alert(ERRO_DADOS_OBRIGATORIOS + '\n' + this.camposNaoPreenchidos);
        alert(this.camposNaoPreenchidos);
      }

    } else {
      alert(ERRO_ASSUNTO_OBRIGATORIO);
    }
  }

  confirm(): void {
    // Deverá ser executada toda a lógica de envio da denúncia
    this.onSubmit();

    this.modalRef.hide();
  }

  decline(): void {

    this.modalRef.hide();
    this.router.navigate([PAGINA_LOGIN], { queryParams: { url: this.urlDenuncia } });

  }

  // TODO Verificar se deverão ser retirados
  // Método antigo de validação de campos (OS 1202 - Verificar se deverá ser retirado)
  isValidoRegrasDenunciaAntigo() {
    var retorno = true;

    // Caso não seja dado legado, será tratado pela única classificação que existirá.
    if (this.service.denuncia.value.listaClassificacao.length == 1) {
      var idClassificacao = this.service.denuncia.value.listaClassificacao[0].id;
      this.tratarMensagensErroCamposClassificacao(idClassificacao);
      retorno = this.camposNaoPreenchidos != "" ? false : true;
    }

    if (!this.service.denuncia.valid) {
      retorno = false;
    }

    return retorno;

  }

  // Tratamento antigo de mensagens (OS 1202 - Verificar se deverá ser retirado)
  tratarMensagensErroCamposClassificacao(idClassificacao: any) {

    // Campos de Cartórios Extrajudiciais Capital
    if (idClassificacao === this.CLASSIFICACAO_CARTORIO_EXTRAJUDICIAL_CAPITAL) {

      if (this.service.denuncia.value.codigoCNS == null || this.service.denuncia.value.codigoCNS == '') {
        this.camposNaoPreenchidos += "\n Nome do Cartório";
      }

      if (this.service.denuncia.value.localidade == '') {
        this.camposNaoPreenchidos += ",\n Localidade";
      }

      // Campos de Cartórios Extrajudiciais Interior
    } else if (idClassificacao === this.CLASSIFICACAO_CARTORIO_EXTRAJUDICIAL_INTERIOR) {

      if (this.service.denuncia.value.codigoMunicipio == null || this.service.denuncia.value.codigoMunicipio == '') {
        this.camposNaoPreenchidos += "\n Municipio";
      }

      if (this.service.denuncia.value.codigoCNS == null || this.service.denuncia.value.codigoCNS == '') {
        this.camposNaoPreenchidos += ",\n Nome do Cartório";
      }

      if (this.service.denuncia.value.localidade == '') {
        this.camposNaoPreenchidos += ",\n Localidade";
      }

      // Campos de Servidor Interior
    } else if (idClassificacao === this.CLASSIFICACAO_SERVIDOR_INTERIOR) {

      if (this.service.denuncia.value.codigoMunicipio == null || this.service.denuncia.value.codigoMunicipio == '') {
        this.camposNaoPreenchidos += "\n Comarca";
      }
    }
  }

  homeDenunciaAnonima() {
    this.router.navigate([PAGINA_LOGIN], { queryParams: { url: this.urlDenuncia } });
  }

}
